<template>
	<div>
		<div
			v-for="(item, i) in widths"
			:key="i"
			class="h-4 mb-4 skeleton--shade-4"
			:style="`width: ${widths[i]}%;`"
		/>
	</div>
</template>

<script>
	export default {
		name: 'TreeViewSkeleton',
		setup() {
			return {
				widths: [35, 85, 65, 50, 75, 48, 80, 64, 77]
			};
		}
	};
</script>